module.exports = __webpack_public_path__ + "img/step-4.228d00aa.jpg";